module.exports = __webpack_public_path__ + "media/images/gmfrcLogo-0cee5960.jpeg";